<template>
    <facility-landing-buttons />
</template>

<script setup lang="ts">
import { definePageMeta } from '#imports'
import FacilityLandingButtons from '~/components/Layouts/FacilityLandingButtons.vue'

definePageMeta({
    layout: 'org'
})
</script>
